import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { LogIn, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QuickPunch = ({ compact = false }) => {
  const { isModuleVisible } = useAuth();
  const [status, setStatus] = useState(null);
  const [punching, setPunching] = useState(false);

  const visible = isModuleVisible('personal');

  const loadStatus = useCallback(async () => {
    if (!visible) return;
    try {
      const res = await axios.get(`${API}/personal/timeclock/status`);
      setStatus(res.data);
    } catch { setStatus(null); }
  }, [visible]);

  useEffect(() => { loadStatus(); }, [loadStatus]);

  if (!visible || !status) return null;

  const inside = status.inside;

  const punch = async () => {
    setPunching(true);
    try {
      await axios.post(`${API}/personal/timeclock/punch`, { type: status.next_action });
      const hhmm = new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      toast.success(status.next_action === 'in' ? `Entrada registrada a las ${hhmm}` : `Salida registrada a las ${hhmm}`);
      loadStatus();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al fichar');
    } finally {
      setPunching(false);
    }
  };

  if (compact) {
    return (
      <button
        onClick={punch}
        disabled={punching}
        className={`p-2 rounded-lg relative ${inside ? 'text-orange-400 hover:bg-slate-800' : 'text-green-400 hover:bg-slate-800'}`}
        title={inside ? 'Fichar salida' : 'Fichar entrada'}
        data-testid="quick-punch-mobile"
      >
        {inside ? <LogOut size={22} /> : <LogIn size={22} />}
        {inside && <span className="absolute top-1 right-1 w-2 h-2 bg-green-400 rounded-full animate-pulse" />}
      </button>
    );
  }

  return (
    <div className="px-4 pb-1">
      <button
        onClick={punch}
        disabled={punching}
        data-testid="quick-punch-btn"
        className={`w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-semibold text-sm transition-colors disabled:opacity-60 ${
          inside
            ? 'bg-orange-500/15 text-orange-400 hover:bg-orange-500/25 border border-orange-500/30'
            : 'bg-green-500/15 text-green-400 hover:bg-green-500/25 border border-green-500/30'
        }`}
      >
        {inside ? <LogOut size={16} /> : <LogIn size={16} />}
        {punching ? 'Fichando...' : (inside ? 'Fichar salida' : 'Fichar entrada')}
        {inside && <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse ml-1" />}
      </button>
    </div>
  );
};
